import { inject, Injectable } from '@angular/core';
import { ProfileService } from '@outlaw/core';

declare var gtag: any;

export interface GtagParams {
  datetime: string;
  OS: string;
  user_id: string;
}

@Injectable({
  providedIn: 'root',
})
export class GtagService {
  private profileService = inject(ProfileService);

  get userId() {
    return this.profileService.getUser().passport_uuid;
  }

  log(event: string, params: Record<string, any>): void {
    gtag('event', event, params);
  }

  getBaseParams(): GtagParams {
    const datetime = new Date().toISOString();
    const OS = 'web';
    const userId = this.userId;

    return { datetime, OS, user_id: userId };
  }
}
